import styles from './Home.module.css';
import home1 from './../../img/home/home1.jpeg';
import home2 from './../../img/home/home2.jpeg';
import home3 from './../../img/home/home3.jpeg';

export const Home = () => {
    return (
        <div className={styles.containerBlock}>
                    <div className={styles.photoContainer}>
            <img src={home2} alt="" />
        </div>
        <div className={styles.photoContainer}>
            <img src={home1} alt="" />
        </div>
        <div className={styles.photoContainer}>
            <img src={home3} alt="" />
        </div>
    </div>
    )
}